function isInRange(index, ranges) {
  return ranges.some(([a, b]) => {
    const min = Math.min(a, b);
    const max = Math.max(a, b);
    return min <= index && max >= index;
  });
}

export default isInRange;
